// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}

@media only screen and (min-width: 1280px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 25%;
    max-width: 25%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1279px) and (min-width: 960px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 33%;
    max-width: 33%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) and (min-width: 600px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 599px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/ads/ads.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,wBAAA;AACJ;;AAGA;EACI;IACI,aAAA;IACA,cAAA;IACA,sBAAA;EAAN;AACF;AAKA;EACI;IACI,aAAA;IACA,cAAA;IACA,sBAAA;EAHN;AACF;AASA;EACI;IACI,aAAA;IACA,cAAA;IACA,sBAAA;EAPN;AACF;AAYA;EACI;IACI,cAAA;IACA,eAAA;IACA,sBAAA;EAVN;AACF","sourcesContent":["h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n\r\n// Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width: 1280px) {\r\n    .fxFlex-25-33md-50sm-100xs {\r\n        flex: 1 1 25%;\r\n        max-width: 25%;\r\n        box-sizing: border-box;\r\n    }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 1280px i pogolemi od 960px (md uredi)\r\n@media only screen and (max-width: 1279px) and (min-width:960px) {\r\n    .fxFlex-25-33md-50sm-100xs {\r\n        flex: 1 1 33%;\r\n        max-width: 33%;\r\n        box-sizing: border-box;\r\n    }\r\n}\r\n\r\n\r\n\r\n// Media query za site uredi pomali od 960px i pogolemi od 600px (sm uredi)\r\n@media only screen and (max-width: 959px) and (min-width:600px) {\r\n    .fxFlex-25-33md-50sm-100xs {\r\n        flex: 1 1 50%;\r\n        max-width: 50%;\r\n        box-sizing: border-box;\r\n    }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 600px (xs uredi)\r\n@media only screen and (max-width: 599px) {\r\n    .fxFlex-25-33md-50sm-100xs {\r\n        flex: 1 1 100%;\r\n        max-width: 100%;\r\n        box-sizing: border-box;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
